import type { ReactNode } from "react";
import { Text } from "react-native";
import type { StyleProp, TextStyle } from "react-native";
import { semanticColors } from "../theme/tokens";

type Props = {
  children: ReactNode;
  numberOfLines?: number;
  style?: StyleProp<TextStyle>;
};

/** Shared title role for empty and completed state banners. */
export function EmptyStateTitleText({ children, numberOfLines, style }: Props) {
  return (
    <Text
      className="font-dm-sans"
      numberOfLines={numberOfLines}
      style={[
        {
          fontSize: 14,
          lineHeight: 18,
          color: semanticColors.text.primary,
          fontWeight: "700",
        },
        style,
      ]}
    >
      {children}
    </Text>
  );
}

/** Shared supporting role for empty and completed state banners. */
export function EmptyStateSubtitleText({
  children,
  numberOfLines,
  style,
}: Props) {
  return (
    <Text
      className="font-dm-sans"
      numberOfLines={numberOfLines}
      style={[
        {
          fontSize: 12,
          lineHeight: 16,
          color: semanticColors.text.secondary,
          fontWeight: "500",
          marginTop: 1,
        },
        style,
      ]}
    >
      {children}
    </Text>
  );
}
